// In-app replacements for window.confirm/alert (plan A7): a minimal native
// <dialog> styled with the app's tokens, localized, Esc/backdrop = cancel.

import { esc, h } from "../dom.ts";
import { t } from "../i18n/index.ts";

export function confirmDialog(
  message: string,
  opts: { confirmLabel?: string; danger?: boolean; hideCancel?: boolean } = {},
): Promise<boolean> {
  return new Promise((resolve) => {
    const dlg = h(`
      <dialog class="app-dialog">
        <p class="dialog-msg">${esc(message)}</p>
        <div class="dialog-actions">
          ${opts.hideCancel ? "" : `<button class="btn ghost" value="cancel" type="button">${t("common.cancel")}</button>`}
          <button class="btn ${opts.danger ? "danger" : "primary"}" value="ok" type="button">${esc(opts.confirmLabel ?? t("common.confirm"))}</button>
        </div>
      </dialog>`) as HTMLDialogElement;
    dlg.addEventListener("click", (e) => {
      if (e.target === dlg) dlg.close("cancel"); // backdrop click
    });
    dlg.querySelectorAll("button").forEach((b) => b.addEventListener("click", () => dlg.close(b.value)));
    dlg.addEventListener("close", () => {
      resolve(dlg.returnValue === "ok");
      dlg.remove();
    });
    document.body.append(dlg);
    dlg.showModal();
  });
}

export function alertDialog(message: string): Promise<void> {
  return confirmDialog(message, { confirmLabel: t("common.ok"), hideCancel: true }).then(() => undefined);
}
